/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TWFactory, TWFactoryInterface } from "../TWFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "contractType",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "version",
        type: "uint256",
      },
    ],
    name: "ImplementationAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isApproved",
        type: "bool",
      },
    ],
    name: "ImplementationApproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "proxy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "deployer",
        type: "address",
      },
    ],
    name: "ProxyDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FACTORY_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
    ],
    name: "addImplementation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "approval",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_toApprove",
        type: "bool",
      },
    ],
    name: "approveImplementation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "currentVersion",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_type",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "deployProxy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "_salt",
        type: "bytes32",
      },
    ],
    name: "deployProxyByImplementation",
    outputs: [
      {
        internalType: "address",
        name: "deployedProxy",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_type",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "_salt",
        type: "bytes32",
      },
    ],
    name: "deployProxyDeterministic",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "deployer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_type",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_version",
        type: "uint256",
      },
    ],
    name: "getImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract TWRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TWFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TWFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TWFactory__factory extends ContractFactory {
  constructor(...args: TWFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TWFactory";
  }

  deploy(
    _trustedForwarder: string,
    _registry: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TWFactory> {
    return super.deploy(
      _trustedForwarder,
      _registry,
      overrides || {}
    ) as Promise<TWFactory>;
  }
  getDeployTransaction(
    _trustedForwarder: string,
    _registry: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _trustedForwarder,
      _registry,
      overrides || {}
    );
  }
  attach(address: string): TWFactory {
    return super.attach(address) as TWFactory;
  }
  connect(signer: Signer): TWFactory__factory {
    return super.connect(signer) as TWFactory__factory;
  }
  static readonly contractName: "TWFactory";
  public readonly contractName: "TWFactory";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TWFactoryInterface {
    return new utils.Interface(_abi) as TWFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TWFactory {
    return new Contract(address, _abi, signerOrProvider) as TWFactory;
  }
}
